import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from 'react';
import EventSelected from './EventSelectedComponent'
import './SliderComponent.scss'
import {
    ContentProxyRaceDay,
    ContentProxyRaceDayStatus,
    ContentProxyRaceEvent
} from "../../../../models/contentProxyModel";
import {BroadcasterConfigModel} from "../../../../models/broadcasterConfigModel";
import SingleSlider from "./SingleSlider";
import {CurrentRaceEventContext} from "../../../../context/currentRaceEvent.context";

export interface SliderRaceEventHeaderProps {
    activeSlide: ContentProxyRaceEvent | undefined;
    allRaceEvents: ContentProxyRaceEvent[];
    changeRaceEvent: (eventId: string, raceDay: ContentProxyRaceDay, isLiveRace: boolean) => void
    nextEvent: ContentProxyRaceEvent | undefined
    currentSlide: ContentProxyRaceEvent | undefined;
    handleSelect: (event: ContentProxyRaceEvent) => void;
    selectedRaceDayId: string | undefined;
    broadcasterRegionalConfig: BroadcasterConfigModel | undefined;
    separatedSeasons: object | undefined;
    seasonNumbers: string[] | undefined;
    switchRaceEvent: (eventId: string | undefined, raceDayId: string | undefined, isLiveRaceDay: boolean) => void;
    switchEventAndResetTime: (offsetSeconds?: number) => void;
    showWatchButton: boolean;
    setShowWatchButton: Dispatch<SetStateAction<boolean>>
}

const SliderComponent = ({
                             activeSlide,
                             changeRaceEvent,
                             nextEvent,
                             currentSlide,
                             handleSelect,
                             broadcasterRegionalConfig,
                             separatedSeasons,
                             seasonNumbers,
                             switchRaceEvent,
                             switchEventAndResetTime,
                             showWatchButton,
                             setShowWatchButton
                         }: SliderRaceEventHeaderProps) => {

    const {resetEvent} = useContext(CurrentRaceEventContext)
    const [firstRaceDay, setFirstRaceDay] = useState<ContentProxyRaceDay | undefined>()
    const [newSeasonNumbers, setNewSeasonNumbers] = useState<Set<string>>(new Set());
    const [previousSeasonNumbers, setPreviousSeasonNumbers] = useState<string[]>([]);

    useEffect(() => {
        if (!activeSlide) return
        handleSelect(activeSlide)
    }, [activeSlide, handleSelect])

    useEffect(() => {
        if (currentSlide && currentSlide?.raceDays) {
            const firstRace = currentSlide.raceDays.find(day => day.state === ContentProxyRaceDayStatus.InProgress || day.state === ContentProxyRaceDayStatus.ReplayAvailable)
            switchRaceEvent(currentSlide?.contentfulId, firstRace?.contentfulId, firstRace?.state === ContentProxyRaceDayStatus.InProgress);
            switchEventAndResetTime(60)
            setFirstRaceDay(firstRace)
        } else resetEvent()
    }, [currentSlide, currentSlide?.raceDays, switchRaceEvent, switchEventAndResetTime, resetEvent])

// Track new seasons for animation
    useEffect(() => {
        if (seasonNumbers && seasonNumbers.length > 0) {
            const newSeasons = seasonNumbers.filter(season => !previousSeasonNumbers.includes(season));

            if (newSeasons.length > 0 && previousSeasonNumbers.length > 0) {
                setNewSeasonNumbers(new Set(newSeasons));

                // Remove animation class after animation completes
                setTimeout(() => {
                    setNewSeasonNumbers(new Set());
                }, 600); // Match animation duration
            }

            setPreviousSeasonNumbers(seasonNumbers);
        }
    }, [seasonNumbers]);

    return (
        <div className="sliderContainer" id="sliderContainer">
            {currentSlide &&
                <EventSelected event={currentSlide}
                               changeRaceEvent={changeRaceEvent}
                               nextEvent={nextEvent}
                               broadcasterRegionalConfig={broadcasterRegionalConfig}
                               hasVideo={currentSlide?.raceDays && !!currentSlide?.raceDays[0]}
                               firstRaceDay={firstRaceDay}
                               showWatchButton={showWatchButton}
                />}
            <div className='seasonsContainer' style={{ minHeight: 'fit-content' }}>
                {seasonNumbers && seasonNumbers.map(season => {
                    if (+season > 0) {
                        const seasonData = separatedSeasons?.[season];
                        return <SingleSlider
                            key={season}
                            seasonData={seasonData}
                            currentSlide={currentSlide}
                            handleSelect={handleSelect}
                            season={season}
                            changeRaceEvent={changeRaceEvent}
                            setShowWatchButton={setShowWatchButton}
                            isNewSeason={newSeasonNumbers.has(season)}
                        />
                    } else return null
                })}
            </div>
        </div>
    );
};

export default SliderComponent;
